import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import ExternalSourceHeaderNav from '../../common/headerNav/ExternalSourceHeaderNav';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { externalDataGrouping } from './connectorUtils';
import Swal from 'sweetalert2';
import {
  APP_WRITE,
  DIRECTUS,
  SUPABASE,
  XANO,
  XATA,
  AIRTABLE,
  SALESFORCE,
  DRAPCODE,
  DATA_SOURCE,
} from 'drapcode-constant';
import DataSourceLinks from './DataSourceLinks';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { showAlertHtmlWithFeedback, showNotice } from '../../common/utils/alert';
import { extractFieldSupaBase, transformCollectionsAppwrite } from './validationUtils';
import { filterCollections, filterXanoCollection } from './common/common_utils';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class DefaultPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: DRAPCODE, headers: [] };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    let connectorType = DRAPCODE;
    const headers = [];
    await actions.getExternalDataBase({ projectId, version });
    actions.getPermissionFlags({ projectId });
    this.setState({ activeTab: connectorType, headers });
    actions.loadProjectDetail({ projectId, version });
  }
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  toggle = (tab) => {
    this.setState({ activeTab: tab });
  };
  handleEdit = (id, type) => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    if (type === APP_WRITE) {
      history.push(`/data-connector/${version}/v/${projectId}/appwrite-edit/${id}`);
    } else if (type === SUPABASE) {
      history.push(`/data-connector/${version}/v/${projectId}/supabase-edit/${id}`);
    } else if (type === XATA) {
      history.push(`/data-connector/${version}/v/${projectId}/xata-edit/${id}`);
    } else if (type === DIRECTUS) {
      history.push(`/data-connector/${version}/v/${projectId}/directus-edit/${id}`);
    } else if (type === AIRTABLE) {
      history.push(`/data-connector/${version}/v/${projectId}/airtable-edit/${id}`);
    } else if (type === SALESFORCE) {
      history.push(`/data-connector/${version}/v/${projectId}/salesforce-update/${id}`);
    } else {
      history.push(`/data-connector/${version}/v/${projectId}/external-database-edit/${id}`);
    }
  };
  handleDelete = async (externalDatabaseId) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;

    //Fetch Linked Collections
    await actions.loadProjectExternalDbCollections({
      projectId,
      version,
      externalDatabaseId,
    });
    const { collectionsExternalDataSources } = this.props.dataConnector;
    let dataExists = collectionsExternalDataSources && collectionsExternalDataSources.length > 0;
    //Fetch Linked Events
    if (!dataExists) {
      await actions.loadEventsExternalDataSource({
        projectId,
        version,
        externalDatabaseId,
      });
      const { eventsExternalDataSources } = this.props.dataConnector;
      dataExists = eventsExternalDataSources && eventsExternalDataSources.length > 0;
    }
    //Fetch Linked External APIs
    if (!dataExists) {
      await actions.loadExternalApisExternalDb({
        projectId,
        version,
        externalDatabaseId,
      });
      const { externalApisExternalDataSources } = this.props.dataConnector;
      dataExists = externalApisExternalDataSources && externalApisExternalDataSources.length > 0;
    }

    if (dataExists) {
      const title = 'Cannot Delete';
      const msg = `Before deleting this DataSource, please ensure that any linked Collections, Events, and External APIs are removed.`;
      showNotice(msg, title);
    } else {
      const confirmationMsg = `This action will delete both the DataSource configuration and the DataSource itself.`;
      const feedbackTitle = `Deleted!`;
      const feedbackIcon = `success`;
      const feedbackMsg = `DataSource has been deleted.`;

      const preConfirm = async () => {
        await actions.deleteExternalDatabase({ projectId, version, externalDatabaseId });
        await actions.getExternalDataBase({ projectId, version });
      };

      const feedbackData = {
        feedbackTitle,
        feedbackIcon,
        feedbackHtml: feedbackMsg,
      };

      showAlertHtmlWithFeedback(confirmationMsg, preConfirm, 'Yes, delete it!', feedbackData);
    }
  };
  renderDatabaseCell = (entry) => {
    const databaseNames = Object.keys(entry.completeData).map(
      (dataKey) => entry.completeData[dataKey].name,
    );
    if (databaseNames.every((name) => !name)) {
      return '_ _';
    }
    return databaseNames.join(' ');
  };
  renderNumberOfTablesCell = (entry) => {
    return entry.completeData.tables ? `${entry.completeData.tables.length} tables` : '0';
  };
  renderDataSourceName = (entry) => {
    return entry.name;
  };
  renderDataSourceType = (entry) => {
    const sourceType = entry.type;
    let formattedType = sourceType.charAt(0).toUpperCase() + sourceType.slice(1).toLowerCase();
    if (formattedType.includes('_')) {
      formattedType = formattedType.replace(/_/g, '');
    }
    return formattedType;
  };
  renderTableRow = (entry) => {
    const { updateTablesAndFieldsPending, permissionFlags } = this.props.dataConnector;
    let flag;

    if (permissionFlags && permissionFlags.length > 0) {
      flag = permissionFlags.includes(DATA_SOURCE);
    }
    return (
      <tr className="text-left td-align-middle" key={entry.uuid}>
        <td>{this.renderDataSourceName(entry)}</td>
        <td>{this.renderDataSourceType(entry)}</td>
        <td>{this.renderDatabaseCell(entry)}</td>
        <td>{this.renderNumberOfTablesCell(entry)}</td>
        <td className="text-right">
          <button
            className="btn btn-xs btn-theme-green"
            disabled={updateTablesAndFieldsPending}
            onClick={() =>
              this.handleUpdateDataSources(entry.uuid, entry.type, entry.setting, entry)
            }
          >
            <i className="wb webconnect-refresh" title="Refresh"></i>
          </button>
          &nbsp;
          <button
            className="btn btn-xs btn-primary"
            onClick={() => this.handleEdit(entry.uuid, entry.type)}
          >
            <i className="wb webconnect-pencil"></i>
          </button>
          &nbsp;
          <button
            className="btn btn-xs btn-theme-delete"
            style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
            onClick={() => (flag ? this.handleDelete(entry.uuid) : undefined)}
          >
            <i className="wb webconnect-trash-solid"></i>&nbsp;
            {flag ? null : (
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            )}
          </button>
        </td>
      </tr>
    );
  };

  handleUpdateDataSources = async (dbUuid, type, setting, item) => {
    const { history, actions, match } = this.props;
    const { projectId, version } = match.params;
    const showConfirmation = async () => {
      return Swal.fire({
        title: 'Are you sure?',
        text: `This action will retrieve the latest details from your specified ${type} account.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, proceed!',
        cancelButtonText: 'Cancel',
      });
    };

    switch (type) {
      case SUPABASE:
        const supabaseConfirmation = await showConfirmation();
        if (supabaseConfirmation.isConfirmed) {
          await this.handleSupabaseTables(dbUuid, setting);
        }
        break;
      case APP_WRITE:
        const appwriteConfirmation = await showConfirmation();
        if (appwriteConfirmation.isConfirmed) {
          await this.handleAppwriteTables(dbUuid, setting, item);
        }
        break;
      case DIRECTUS:
        const directusConfirmation = await showConfirmation();
        if (directusConfirmation.isConfirmed) {
          await this.handleDirectusTables(dbUuid, setting, item);
        }
        break;
      case XANO:
        const xanoConfirmation = await showConfirmation();
        if (xanoConfirmation.isConfirmed) {
          await this.handleXanoTables(dbUuid, setting, item);
        }
        break;
      default:
        const externalDBConfirmation = await showConfirmation();
        if (externalDBConfirmation.isConfirmed) {
          await actions.getExternalDataBase({ projectId, version });
        }
        break;
    }
  };
  handleSupabaseTables = async (dbUuid, setting) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { supabase_key, dataBaseUrl } = setting;
    await actions.getSupabaseData({
      developerKey: supabase_key,
      dataBaseUrl,
      projectId,
      version,
    });
    const { dataConnector } = this.props;
    const { supabaseData } = dataConnector || '';
    let supabaseCollectionTables = '';
    supabaseCollectionTables = extractFieldSupaBase(supabaseData);
    await actions.updateTablesAndFields({
      projectId,
      version,
      dbUuid,
      data: supabaseCollectionTables,
    });
    await actions.getExternalDataBase({ projectId, version });
  };
  handleAppwriteTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { completeData } = item ? item : '';
    const { database } = completeData ? completeData : '';
    const { id } = database ? database : '';
    await actions.getCollectionsByAppwrite({
      settingData: setting,
      databaseId: id,
      version,
      projectId,
    });
    const { dataConnector } = this.props;
    const { collectionsByAppwrite } = dataConnector || '';
    const { collections } = collectionsByAppwrite ? collectionsByAppwrite : '';
    const transformedResult = transformCollectionsAppwrite(collections);
    await actions.updateTablesAndFieldsAppwrite({
      projectId,
      version,
      dbUuid,
      data: transformedResult,
    });
    await actions.getExternalDataBase({ projectId, version });
  };
  handleDirectusTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { Authorization, baseUrl } = setting ? setting : '';
    let clearToken = Authorization.replace('Bearer ', '');
    await actions.getCollectionsForDirectus({ projectId, version, baseUrl, userToken: clearToken });

    if (this.props.dataConnector.collectionByDirectus) {
      const collections = this.props.dataConnector.collectionByDirectus;
      const collectionNames = filterCollections(collections);
      await actions.updateDirectusTables({
        projectId,
        version,
        dbUuid,
        data: collectionNames,
      });
      await actions.getExternalDataBase({ projectId, version });
    }
  };
  handleXanoTables = async (dbUuid, setting, item) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { xanoApiAccessToken } = setting ? setting : '';
    const { completeData } = item ? item : '';
    const { workspace } = completeData ? completeData : '';
    const { id } = workspace ? workspace : '';
    await actions.getXanoTable({ token: xanoApiAccessToken, projectId, id, version });
    if (this.props.dataConnector.xanoDataSourceTables) {
      const collections = this.props.dataConnector.xanoDataSourceTables;
      const collectionNames = filterXanoCollection(collections);
      await actions.updateDirectusTables({
        projectId,
        version,
        dbUuid,
        data: collectionNames,
      });
      await actions.getExternalDataBase({ projectId, version });
    }
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <div className="main">
          <div className="section">
            <div className="container data-source">
              <PermissionDenied message="Data Source" />
            </div>
          </div>
        </div>
      );
    }
    const { match, dataConnector } = this.props;
    const { projectId, version } = match.params;
    const { externalDataBaseData, getExternalDataBasePending } = dataConnector;
    const { headers, activeTab } = this.state;
    const data = externalDataGrouping(externalDataBaseData);
    return (
      <div className="main">
        <div className="section">
          <div className="container data-source">
            <ExternalSourceHeaderNav
              title="Data Source"
              titleIcon="data-source"
              projectId={projectId}
              version={version}
              headers={headers}
              activeTab={activeTab}
              enableRestApi={false}
              enableZapier={false}
              enableDrapcode={true}
              toggle={this.toggle}
            />
            {getExternalDataBasePending ? (
              <CommonPageComponent>
                <div className="text-center">
                  <CustomLoader loading={getExternalDataBasePending} size="20px" color="#303453" />
                </div>
              </CommonPageComponent>
            ) : (
              <div className="row mx-auto">
                <ParentContentCardMultiHeader
                  isSearch={false}
                  btnSize="sm"
                  handleSearch={this.handleSearch}
                  updateSearchTerm={this.updateSearchTerm}
                  title="Data Sources"
                  icon="data-source"
                  bgColor="drapcode-violet"
                  projectId={projectId}
                  version={version}
                  CtaComponent={<DataSourceLinks projectId={projectId} version={version} />}
                >
                  {getExternalDataBasePending && (
                    <div className="text-center">
                      <CustomLoader
                        loading={getExternalDataBasePending}
                        size="20px"
                        color="#303453"
                      />
                    </div>
                  )}
                  {externalDataBaseData ? (
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover table-sm table-word-break connector-list">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Source</th>
                            <th>Database</th>
                            <th>Number of Tables</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(data).map((database) =>
                            data[database].map((entry) => this.renderTableRow(entry)),
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="col-md-12">
                      <h5 className="text-center">No Data Source Exist!</h5>
                    </div>
                  )}
                </ParentContentCardMultiHeader>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
    home: state.home,
    common: state.common,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
